"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function processQueue(entryName) {
    var ginit = window.ginit;
    if (ginit) {
        var queue = ginit.q ? ginit.q.slice() : [];
        if (queue.length === 0) {
            console.warn("Warning! \"" + entryName + "\" tries to handle empty queue. Make call to \"ginit\" before \"processQueue\"");
        }
        // tslint:disable:prefer-for-of
        for (var index = 0; index < queue.length; index++) {
            var _a = queue[index] || [], methodName = _a[0], args = _a[1];
            var method = methodName && window.__app && window.__app[methodName];
            if (typeof method !== 'function') {
                console.warn("\"" + entryName + "\" entry can not handle queued command: ginit(\"" + methodName + "\") \n Abort queue processing.");
                continue;
            }
            try {
                method(args);
                ginit.q.shift(); // remove executed command from queue mutating original array
                console.warn("\"" + entryName + "\" entry successfully handled queued command: ginit(\"" + methodName + "\")");
            }
            catch (err) {
                console.error("\"" + entryName + "\" failed during \"" + methodName + "\" execution", err);
            }
        }
    }
}
exports.default = processQueue;
// window.processGQueue=function(){if(!window.ginit)return;var q=ginit.q.slice()||[];q.every(function(c,i){var m=window.__app[c[0]];if(typeof m!=='function')return;try{m(c[1]);window.ginit.q.shift()}catch(err){console.error(err)}return true;})}
//# sourceMappingURL=processQueue.js.map